module.exports = __webpack_public_path__ + "static/media/hour-glassAdmin.38d670de.png";